import { useState, useEffect } from "react";
import {
  getGeofenceByFleetId,
  getRobotStatus,
  getActiveMission,
  getFleetConfigByFleetId,
} from "../API";
import { findNorthWestAndSouthEast } from "../utils";

import { useParams } from "react-router-dom";
import RobotTracking from "./RobotTracking";
import { useRobotPathMqtt } from "../hooks/useRobotPathMqtt";
function RobotStatus() {
  const [isLoading, setIsLoading] = useState(true);
  const [robotDetails, setRobotDetails] = useState(null);
  const [robotActiveMission, setRobotActiveMission] = useState([]);
  const { robotId } = useParams();
  const [maxBoundCordinates, setBoundCordinates] = useState({});
  const [geofenceCoordinates, setGeofenceCoordinates] = useState([]);
  const { robotPath } = useRobotPathMqtt(robotId);
  const fetchBoundCordinates = () => {
    getGeofenceByFleetId(process.env.REACT_APP_FLEETID).then(
      (res) => {
        setBoundCordinates(findNorthWestAndSouthEast(res.data.geofence));
        // Store raw geofence as [lng, lat] pairs for map rendering
        setGeofenceCoordinates(
          res.data.geofence.map((point) => [point.lng, point.lat])
        );
      }
    );
  }
  useEffect(() => {
    const intervalId = setInterval(() => {
      getRobotStatus(robotId)
        .then((res) => {
          setRobotDetails(res?.data?.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(true);
          console.log("Error ", err);
        });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  useEffect(() => {
    fetchBoundCordinates();
    getRobotStatus(robotId)
  },[robotId])

  useEffect(() => {
    const intervalId = setInterval(() => {
      getActiveMission(robotId)
        .then((response) => {
          setRobotActiveMission(response?.data);
        })
        .catch((err) => {
          setIsLoading(true);
          console.log("Error ", err);
        });
    }, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const fetchFleetConfig = async () => {
      try {
        const response = await getFleetConfigByFleetId(
          robotDetails?.robotStatus?.fleetId
        );
        const data = response?.data?.data;
        localStorage.setItem("fleetConfig", JSON.stringify(data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (robotDetails) {
      fetchFleetConfig();
    }
  }, [robotDetails]);

  return (
    <div>
      {/* {false ? (
        <Loader />
      ) : ( */}
      <RobotTracking
        maxBoundCordinates={maxBoundCordinates}
        robotDetails={robotDetails}
        robotActiveMission={robotActiveMission}
        isLoading={isLoading}
        robotPath={robotPath}
        geofenceCoordinates={geofenceCoordinates}
      />
      {/* )} */}
    </div>
  );
}

export default RobotStatus;
